package twist.mena.sports.admin.state

import kotlinx.browser.localStorage
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive
import org.w3c.dom.get
import org.w3c.dom.set
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi

object AuthState {
    private const val TOKEN_KEY = "admin_jwt"

    val isAuthenticated: Boolean
        get() = getToken() != null && !isExpired()

    fun getToken(): String? = localStorage[TOKEN_KEY]

    fun setToken(token: String) {
        localStorage[TOKEN_KEY] = token
    }

    fun logout() {
        localStorage.removeItem(TOKEN_KEY)
    }

    fun getEmail(): String? = getClaim("email")

    fun getRole(): String? = getClaim("role")

    @OptIn(ExperimentalEncodingApi::class)
    private fun getClaim(claim: String): String? {
        val token = getToken() ?: return null
        return try {
            val parts = token.split(".")
            if (parts.size != 3) return null
            val payload = Base64.decode(parts[1].padBase64())
            val json = Json.parseToJsonElement(payload.decodeToString())
            json.jsonObject[claim]?.jsonPrimitive?.content
        } catch (e: Exception) {
            null
        }
    }

    @OptIn(ExperimentalEncodingApi::class)
    private fun isExpired(): Boolean {
        val token = getToken() ?: return true
        return try {
            val parts = token.split(".")
            if (parts.size != 3) return true
            val payload = Base64.decode(parts[1].padBase64())
            val json = Json.parseToJsonElement(payload.decodeToString())
            val exp = json.jsonObject["exp"]?.jsonPrimitive?.content?.toLongOrNull() ?: return true
            val now = (js("Date.now()") as Double).toLong() / 1000
            now >= exp
        } catch (e: Exception) {
            true
        }
    }

    private fun String.padBase64(): String {
        val padding = (4 - length % 4) % 4
        return this.replace('-', '+').replace('_', '/') + "=".repeat(padding)
    }
}
